var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('sds-input-control',{attrs:{"label":_vm.label}},[_c('v-text-field',_vm._g(_vm._b({attrs:{"outlined":"","dense":"","hide-details":"","aria-label":_vm.label,"required":_vm.required,"rules":_setup.rules}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }